<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">领取成功</h2>
            <p class="weui-msg__desc">优惠券已经领取到了您的账户，欢迎使用到家服务！</p>
            <p class="weui-msg__desc" v-if="tempPasswd"><br>我们已经为您的手机号注册了到家账号<br>请点击下方按钮设置密码</p>
        </div>


        <div class="btn-box" v-if="tempPasswd">
          <div class="btn active" @click="$router.push('/new-password')">设置账号密码</div><br>
        </div>
        <div class="btn-box" v-else>
          <div class="btn active" @click="goto('/coupon-list')">查看优惠券</div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'reg-success',
  data () {
    return {
      tempPasswd:false
    }
  },
  created: function () {
    if(localStorage.tempPasswd){
      this.tempPasswd = true;
    }
  },
  methods: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/coupon/get-success.vue